export default __webpack_public_path__ + "static/media/foodies.ebc1f17b.gif";